import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { HeaderService } from '../../../Services/HeaderService';

@Component({
  selector: 'app-header-view',
  templateUrl: './header-view.component.html',
  styleUrls: ['./header-view.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class HeaderViewComponent implements OnInit {

  headerSettings : any  = {};
  constructor(private _headerService : HeaderService) {
    _headerService.headerSettings.subscribe(data=>{
      this.headerSettings = data;
    })
   }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/headers/header-view/header-view.component.ts